import { Alert } from "antd";

interface FailedGroupsBannerProps {
  failedGroups: string[];
  onClose: () => void;
}

const FailedGroupsBanner = ({
  failedGroups,
  onClose
}: FailedGroupsBannerProps) => {
  if (failedGroups.length === 0) return null;

  return (
    <Alert
      className="mt-5"
      type="error"
      showIcon
      closable
      onClose={onClose}
      message="Sync issue"
      description={`Failed to sync users from the following group${
        failedGroups.length === 1 ? "" : "s"
      }: ${failedGroups.join(", ")}`}
    />
  );
};

export default FailedGroupsBanner;
